import { useState } from "react";
import type { OrderCompletionPreview, OrderDetail } from "@cyh/contracts";
import { api } from "../api";
import { useLanguage } from "../i18n";
import { Modal } from "./fulfillment/Shared";

export function OrderCompletionButton({ order, onCompleted }: { order: OrderDetail; onCompleted: (order: OrderDetail) => Promise<void> }) {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);
  const [notes, setNotes] = useState("");
  const [preview, setPreview] = useState<OrderCompletionPreview | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const close = () => { if (!busy) { setOpen(false); setPreview(null); setError(""); } };
  async function submit() {
    if (busy) return;
    setBusy(true); setError("");
    try {
      if (!preview) setPreview(await api.previewOrderCompletion(order.id, order.version, notes));
      else {
        const updated = await api.completeOrder(order.id, preview.token);
        setOpen(false); setPreview(null);
        await onCompleted(updated);
      }
    } catch (cause) {
      setPreview(null);
      setError(cause instanceof Error ? cause.message : t("结单失败，请刷新后重试", "Could not complete the order. Refresh and retry."));
    } finally { setBusy(false); }
  }
  return <><button className="edit-order-button" onClick={() => setOpen(true)}>{t("确认结单", "Complete order")}</button>{open && <Modal title={t("确认订单结单", "Confirm order completion")} disableClose={busy} onClose={close}>
    <form className="admin-form" onSubmit={event => { event.preventDefault(); void submit(); }}>
      <p className="full-field">{t("订单", "Order")}: <strong>{preview?.orderNo || order.sourceOrderNo || order.orderNo}</strong></p>
      <p className="full-field">{t("结单后订单将标记为已完成，并记录操作人、时间和备注。本操作不会修改金额、收款或产品配置。", "The order will be marked completed, with the operator, time and notes recorded. Amounts, payments and product configuration will not change.")}</p>
      {preview ? <div className="full-field"><strong>{t("结单备注", "Completion notes")}</strong><p style={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>{preview.notes}</p><p>{t("请核对后再次确认；本次确认 5 分钟内有效。", "Review and confirm again. This confirmation expires in 5 minutes.")}</p></div> : <label className="full-field">{t("结单备注", "Completion notes")}<textarea required maxLength={500} rows={3} value={notes} onChange={event => setNotes(event.target.value)} /></label>}
      {error && <div className="error-bar full-field" role="alert">{error}</div>}
      <div className="modal-actions"><button type="button" disabled={busy} onClick={close}>{t("取消", "Cancel")}</button><button className="primary-button" disabled={busy || (!preview && !notes.trim())}>{busy ? t("处理中…", "Processing…") : preview ? t("确认结单", "Confirm completion") : t("下一步：核对结单", "Next: review completion")}</button></div>
    </form>
  </Modal>}</>;
}
